module.exports = __webpack_public_path__ + "img/1012.b8524dab.jpg";